import React from 'react';

export function NotFound() {
  return (
    <div>
      <h1>404 fannst ekki</h1>
    </div>
  );
}
